import type React from 'react';

import * as styles from './styles';

import { BodyText, DescriptionTitle, InfoIcon, Tooltip } from '@cobliteam/base-components';

interface OdometerInfoTooltipProps {
  title?: string;
}

export const OdometerInfoTooltip: React.FC<OdometerInfoTooltipProps> = ({ title = 'Odômetro na data' }) => (
  <Tooltip CustomIcon={InfoIcon} className={styles.totalEventsTooltip} placement='bottom' arrow>
    <div className={styles.tooltipContent}>
      <DescriptionTitle>{title}</DescriptionTitle>
      <BodyText>As informações de odômetro cadastradas aqui não alteram lembretes de manutenção nem a leitura do odômetro digital.</BodyText>
    </div>
  </Tooltip>
);
